import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';

const Footer = () => {
  const { language } = useLanguage();
  const { user, loading } = useAuth();
  const location = useLocation();

  // Do not render footer while loading auth state
  if (loading) {
    return null;
  }

  // Hide footer on login, register, and verify-email pages to avoid scrolling
  const hiddenRoutes = ['/login', '/register', '/verify-email'];
  if (hiddenRoutes.includes(location.pathname)) {
    return null;
  }

  // Hide footer if user is logged in but unverified or pending admin confirmation
  if (user && (!user.email_verified || (!user.is_confirmed && !user.is_admin))) {
    return null;
  }

  return (
    <footer className="w-full py-6 px-4 border-t border-border bg-background mt-auto">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
        <div>
          &copy; {new Date().getFullYear()} Scherenmarket. {language === 'de' ? 'Alle Rechte vorbehalten.' : 'All rights reserved.'}
        </div>
        <div className="flex gap-6">
          <Link to="/impressum" className="hover:text-foreground transition-colors">
            Impressum
          </Link>
          <Link to="/datenschutz" className="hover:text-foreground transition-colors">
            {language === 'de' ? 'Datenschutz' : 'Privacy'}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
